





















import { defineComponent, PropType, onMounted, toRefs, computed } from '@vue/composition-api';
import { SplitTestFormData, AdgroupFormData, SplitTestTargetResult } from '@tt4b/ttam-enums';

import { useKeyMetric } from '../hooks';
// import { generateMetricList } from './config';
// import { useSplitTestStoreGetter } from '@/hooks/creation/splittest/use-split-test-store-getter';
const name = 'ttam-split-test-key-metric';

export default defineComponent({
  name,
  props: {
    splitTestFormData: {
      type: Object as PropType<SplitTestFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const { keyMetricOptions } = useKeyMetric(adgroupData);

    const keyMetric = computed({
      get() {
        return props.splitTestFormData.keyMetric;
      },
      set(val: SplitTestTargetResult) {
        emit('change', val);
      },
    });

    // onMounted(() => {
    //   // 初始化
    //   initKeyMetric(props.adgroupData);
    // });

    return {
      name,
      keyMetricOptions,
      keyMetric,
      // metricListShow,
      // keyMetricList,
    };
  },
});
